export const SLEEP_STATUSES = [
  {
    id: 1,
    text: "覚醒",
  },
  {
    id: 2,
    text: "体動が多い睡眠",
  },
  {
    id: 3,
    text: "体動が少ない睡眠",
  },
];
